import React, { useState } from "react";

const ThoughtsButton = () => {
  const [hover, setHover] = useState(false);
  return (
    <img
      onMouseEnter={() => {
        {
          setHover(true);
        }
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      src="/icons/icon_thought.png"
      className="icon40"
      style={{ filter: hover ? null : "grayscale(100%)", marginLeft: "10px" }}
    />
  );
};

export default ThoughtsButton;
